import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyComponent } from './currency.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [CommonModule, MatTooltipModule],
  declarations: [CurrencyComponent],
  exports: [CurrencyComponent],
})
export class CurrencyModule {}
